const SENSITIVE_QUERY_KEYS = new Set([
  'access_token',
  'refresh_token',
  'token',
  'apikey',
  'api_key',
  'key',
  'password',
  'secret',
  'authorization',
  'unlockcode',
  // CHAT-04: a pergunta do atalho (`/chat-ia?q=`) pode ter dado de paciente.
  'q',
  'texto',
])

/** Links de atalho (`/criar/receita?paciente=…&med=…`) levam nome e remédio na query (INT-07). */
const INTENT_PATH = /^\/criar(\/|$)/

/** Redacts share tokens and patient UUIDs from URL paths (PostHog, Sentry parity — SEC-007 / SEC-031). */
export function redactSensitiveUrlPath(path: string): string {
  if (path.startsWith('/r/')) {
    return '/r/[token]'
  }
  if (path.startsWith('/exam-share/')) {
    return '/exam-share/[token]'
  }
  return path
    .replace(/^(\/patients\/)[0-9a-f-]{36}/i, '$1[id]')
    .replace(/^(\/patient\/)[0-9a-f-]{36}/i, '$1[id]')
}

/**
 * Sanitizes hrefs before analytics or error reporting: redacts path tokens/UUIDs and sensitive query params.
 */
export function sanitizeSensitiveUrl(href: string): string {
  try {
    const url = new URL(href)
    for (const param of [...url.searchParams.keys()]) {
      const low = param.toLowerCase()
      if (
        SENSITIVE_QUERY_KEYS.has(low) ||
        low.includes('token') ||
        low.includes('secret') ||
        low.includes('unlock')
      ) {
        url.searchParams.set(param, '[REDACTED]')
      }
    }
    if (INTENT_PATH.test(url.pathname)) {
      url.search = ''
      url.hash = ''
    }
    url.pathname = redactSensitiveUrlPath(url.pathname)
    return url.toString()
  } catch {
    return href
      .replace(/(\/criar\/[^?#]*)[?#].*$/, '$1')
      .replace(/\/r\/[^/?#]+/g, '/r/[token]')
      .replace(/\/exam-share\/[^/?#]+/g, '/exam-share/[token]')
      .replace(/\/patients\/[0-9a-f-]{36}/gi, '/patients/[id]')
      .replace(/\/patient\/[0-9a-f-]{36}/gi, '/patient/[id]')
  }
}
